import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
import axios from "../../context/axios";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Handpick = () => {
  const [recentViews, setRecentViews] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);

  useEffect(() => {
    // Replace the URL below with your actual API URL
    axios
      .get("/category-tours")
      .then((res) => {
        console.log("Fetched recent views:", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          setRecentViews(res.data.data);
        } else {
          setRecentViews([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching recent views:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth * 0.8; // scroll 80% of container width
      if (direction === "left") {
        scrollRef.current.scrollTo({
          left: scrollLeft - scrollAmount,
          behavior: "smooth",
        });
      } else {
        scrollRef.current.scrollTo({
          left: scrollLeft + scrollAmount,
          behavior: "smooth",
        });
      }
    }
  };

  if (loading)
    return <p className="text-center py-8">Loading recent views...</p>;

  if (!loading && recentViews.length === 0) {
    return <p className="text-center py-8">No recent views found.</p>;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-1 mb-10">
      <h2 className="text-2xl font-semibold mb-6">
        Check out these exclusive weekend getaway packages!
      </h2>

      <div className="relative">
        <button
          onClick={() => scroll("left")}
          className="absolute top-1/2 -left-2 transform -translate-y-1/2 bg-white rounded-full  p-2 hover:bg-gray-100 z-10 hidden md:block"
          aria-label="Scroll left"
        >
          <FaChevronLeft />
        </button>

        <div
          ref={scrollRef}
          className="flex space-x-6 overflow-x-auto scroll-smooth pb-2 no-scrollbar"
          style={{
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            scrollBehavior: "smooth",
          }}
        >
          <style>
            {`
              .no-scrollbar::-webkit-scrollbar {
                display: none;
              }
            `}
          </style>

          <div className="flex space-x-6">
            {recentViews.slice(0, 7).map((tour) => {
              if (!tour) return null;

              return (
                // <a
                //   key={tour._id}
                //   href={`/tours/${tour._id}`}
                //   className="min-w-[280px] bg-white rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 border border-gray-200 flex-shrink-0 flex flex-col"
                // >
                <a
                  key={tour._id}
                  href={`/tours/${tour._id}`}
                  className="w-[340px] h-[320px] bg-white rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 border border-gray-200 flex-shrink-0 flex flex-col overflow-hidden"
                >
                  <div className="relative w-full overflow-hidden rounded-t-lg">
                    {/* <img
                      src={tour.img || tour.image || ""}
                      alt={tour.title}
                      className="w-full object-cover transform hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                      style={{ maxHeight: "250px" }}
                    /> */}
                    <img
                      src={tour.img || tour.image || ""}
                      alt={tour.title}
                      className="w-full h-[200px] object-cover transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>

                  <div className="p-4 flex flex-col flex-grow">
                    <h3 className="text-lg font-semibold mb-2 truncate">
                      {tour.title}
                    </h3>

                    <div className="flex flex-wrap text-gray-600 text-sm gap-3 mb-3">
                      <div className="flex items-center">
                        <span className="font-medium mr-1">Duration:</span>
                        <span>
                          {tour.duration
                            ? `${tour.duration.day}D / ${tour.duration.night}N`
                            : "N/A"}
                        </span>
                      </div>

                      <div className="flex items-center">
                        <span className="font-medium mr-1">Region:</span>
                        {/* You might want to show the region name, here just id */}
                        <span>{tour.region?.$oid || tour.region || "N/A"}</span>
                      </div>
                    </div>

                    <div className="mt-auto flex items-center space-x-3">
                      {tour.originalPrice &&
                        tour.originalPrice > tour.price && (
                          <p className="text-sm text-gray-400 line-through">
                            €{tour.originalPrice.toLocaleString()}
                          </p>
                        )}
                      <p className="text-xl font-bold text-indigo-600">
                      €{tour.price?.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>

        <button
          onClick={() => scroll("right")}
          className="absolute top-1/2 -right-2 transform -translate-y-1/2 bg-white rounded-full shadow-md p-2 hover:bg-gray-100 z-10 hidden md:block"
          aria-label="Scroll right"
        >
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default Handpick;
